<template>
  <div class="flex items-start justify-between gap-10 max-lg:flex-col">
    <!-- Image -->
    <NuxtImg
      :src="data?.image"
      height="803"
      width="565"
      alt="List Image"
      class="w-full rounded-xl"
      loading="lazy"
      format="webp"
    />

    <!-- Content -->
    <div class="w-full">
      <h2 class="lg:text-center mb-6">
        <WrGradientText append-class="text-3xl lg:text-[36px] leading-[1]">
          {{ data?.heading }}
        </WrGradientText>
      </h2>

      <!-- Use div instead of wrapping <p> around v-html -->
      <div
        class="lg:text-xl tracking-[0.5px] mt-4"
        v-html="data?.subheading"
      ></div>

      <ul class="list-disc ml-5 mt-5 gap-5">
        <li
          v-for="item in data?.items"
          :key="item.heading"
          class="text-lg font-semibold"
        >
          {{ item?.heading }}
          <p class="text-base font-normal">{{ item?.description }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  data: {
    heading: string;
    subheading: string; // contains raw HTML
    image: string;
    items: { heading: string; description: string }[];
  };
}>();
</script>
